(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alb-lifestyle-hover"] && !Shopify.designMode) return;
  try {
    /* Wechsel-Knopf (Touch): dreht das Kartenbild zwischen Produkt- und Lifestyle-Bild.
     Capture-Phase, damit der Tipp nicht den Karten-Link (Produktseite) auslöst.
     pointerdown bereitet das Bild schon vor (is-lh-prep = Rückseite sichtbar geschaltet,
     Browser lädt), gedreht wird nach dem Laden, damit keine leere Rückseite erscheint. */
  (function () {
    if (window.__albLhToggle) return;
    window.__albLhToggle = true;
    var html = document.documentElement;
    /* QA-Vorschau von Testvarianten ohne VWO (gilt für die Browser-Sitzung):
       ?alb-ab=emo-fotos,lifestyle  setzt alb-ab-emo-fotos + alb-ab-lifestyle am html
       ?alb-ab=aus                  beendet die Vorschau
       ?alb-lifestyle=an|aus        Kurzform nur für das Lifestyle-Bild */
    try {
      var liste = (sessionStorage.getItem('alb-ab') || '').split(',').filter(Boolean);
      var par = new URLSearchParams(location.search);
      var ab = (par.get('alb-ab') || '').toLowerCase().replace(/[^a-z0-9,-]/g, '');
      if (ab) liste = ab === 'aus' ? [] : ab.split(',').filter(Boolean);
      var ls = par.get('alb-lifestyle');
      if (ls === 'an' && liste.indexOf('lifestyle') < 0) liste.push('lifestyle');
      if (ls === 'aus') liste = liste.filter(function (k) { return k !== 'lifestyle'; });
      if (liste.length) sessionStorage.setItem('alb-ab', liste.join(','));
      else sessionStorage.removeItem('alb-ab');
      liste.forEach(function (k) { html.classList.add('alb-ab-' + k); });
    } catch (err) {}
    function melde(aktion, card) {
      try {
        document.dispatchEvent(new CustomEvent('alb:lifestyle', {
          detail: { aktion: aktion, produkt: (card && card.getAttribute('href') || '').split('?')[0] }
        }));
      } catch (err) {}
    }
    /* Desktop: Mouseover ab 500 ms einmal je Karte melden (nur wenn das Bild sichtbar sein darf) */
    var gesehen = new WeakSet();
    var wartet = new WeakSet();
    document.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      var card = e.target.closest && e.target.closest('.alb-pg-card');
      if (!card || gesehen.has(card) || wartet.has(card)) return;
      var lh = card.querySelector('.alb-lh');
      if (!lh || getComputedStyle(lh).display === 'none') return;
      wartet.add(card);
      var t = setTimeout(function () { wartet.delete(card); gesehen.add(card); melde('hover', card); }, 500);
      card.addEventListener('pointerleave', function () { clearTimeout(t); wartet.delete(card); }, { once: true });
    }, true);
    function prep(card) { card.classList.add('is-lh-prep'); }
    function flip(btn) {
      var card = btn.closest('.alb-pg-card');
      if (!card) return;
      var on = card.getAttribute('data-lh') !== '1';
      card.setAttribute('data-lh', on ? '1' : '0');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Produktbild zeigen' : 'Produkt im Einsatz zeigen');
      melde(on ? 'an' : 'aus', card);
      if (!on) { card.classList.remove('is-lh'); return; }
      prep(card);
      var lh = card.querySelector('.alb-lh');
      var done = false;
      function go() {
        if (done) return;
        done = true;
        if (lh) void lh.offsetWidth;
        requestAnimationFrame(function () {
          if (card.getAttribute('data-lh') === '1') card.classList.add('is-lh');
        });
      }
      if (lh && !(lh.complete && lh.naturalWidth)) {
        lh.addEventListener('load', go, { once: true });
        lh.addEventListener('error', go, { once: true });
        setTimeout(go, 1500);
      } else {
        go();
      }
    }
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest && e.target.closest('.alb-lh-toggle');
      var card = btn && btn.closest('.alb-pg-card');
      if (card) prep(card);
    }, true);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.alb-lh-toggle');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      flip(btn);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var btn = e.target.closest && e.target.closest('.alb-lh-toggle');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      flip(btn);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
